export default __webpack_public_path__ + "static/media/Swift Stygian Festival Stallion.a2391f48.jpg";